document.addEventListener('DOMContentLoaded', () => {

    const isProductPage = window.location.pathname.includes('/products/');

    if (isProductPage) {
        const secondarySections = document.querySelectorAll('.product-info .product-info-secondary');
        secondarySections.forEach(section => {

            const visibleContent = section.innerText.trim();
        
            if (visibleContent === "") {
                section.style.display = 'none';
                console.log('Hidden an empty section');
            }
            
        });
    }

    if (window.location.pathname === '/collections/byd-shark') {
        document.addEventListener('click', (event) => {
                
            const filterBtn = event.target.closest('.tiles-filter-products');
            
            if (filterBtn) {
            const collectionWrapper = document.querySelector('.tiles-collection-wrapper');
            
            if (collectionWrapper) {
                if (collectionWrapper.style.display === 'block') {
                    collectionWrapper.style.display = 'none';
                    } else {
                    collectionWrapper.style.display = 'block';
                    }
                }
            }

        });
    }

});